function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 570;


//////////////////
// WEBPACK FOOTER
// ./submodules/vscode-nls/src
// module id = 570
// module chunks = 0